import { gql } from '@apollo/client';
import customer from '../customer';
import carVariant from '../carVariant';
import model from '../model';
import engine from '../engine';
import baseImage from '../baseImage';
import dealCarPrice from '../deal/dealCarPrice';
import price from '../price';
import dealFeature from '../deal/dealFeature';
import dealFinance from '../deal/dealFinance';
import speckPack from '../speckPack';
import interior from '../interior';
import exterior from '../exterior';
import bodyStyle from '../bodyStyle';

const dealData = {
  DEAL_DATA: gql`
    ${customer.CUSTOMER_DETAILS}
    ${baseImage.BASE_IMAGE}
    ${dealCarPrice.DEAL_CAR_PRICE}
    ${price.PRICE}
    ${dealFinance.DEAL_FINANCE}
    ${dealFeature.DEAL_FEATURE}
    ${carVariant.VARIANT}
    ${model.MODEL}
    ${bodyStyle.BODY_STYLE}
    ${engine.ENGINE}
    ${speckPack.SPECK_PACK}
    ${interior.INTERIOR}
    ${exterior.EXTERIOR}

    fragment DealData on Deal {
      uuid
      car {
        code
        displayName
        images {
          ...BaseImage
        }
        stock {
          vin
          dms
        }
        aggregatedOptions
        configurationSourceUrl
        nameplate {
          code
          attributes {
            shortname
            modelyear
            oemcode
          }
        }
        interior {
          ...Interior
        }
        exterior {
          ...Exterior
        }
        bodyStyle {
          ...BodyStyle
        }
        variant {
          ...Variant
        }
        model {
          ...Model
        }
        engine {
          ...Engine
        }
        specPack {
          ...SpecPack
        }
        prices {
          carPrice {
            ...DealCarPrice
          }
          totalPrice {
            ...Price
          }
          totalFeatures {
            ...Price
          }
        }
        standardFeatures {
          ...DealFeature
        }
        selectedFeatures {
          ...DealFeature
        }
        disclaimers {
          value
          needsToBeTranslated
        }
      }
      finance {
        ...DealFinance
      }
      customer {
        ...CustomerDetails
      }
      location {
        province
        district
        street
      }
      attributes {
        market
        modelyear
        co2
        range
      }
      status
      journeyType
      currency
      region
      country
      brand
      language
      createdAt
      updatedAt
    }
  `,
};

export default dealData;
